import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	'theme': {
		'base': {
			'card': {
				'children': {
					'header': {
						'display': 'flex',
					},
					'title': {
						'font': {
							'size': '16px',
							'weight': '700',
						},
						'max': {
							'width': '2000px',
						},
						'text': {
							'align': 'left',
						},
					},
					'wrapper': {
						'align': {
							'items': 'center',
						},
						'breakpoints': [
							{
								'max': '2000px',
								'style': {
									'margin': {
										'left': 'auto',
									},
									'max': {
										'width': '100%',
									},
								},
							},
						],
						'display': 'flex',
						'flex': {
							'direction': 'column',
						},
						'margin': {
							'left': 'auto',
						},
						'max': {
							'width': '2000px',
						},
					},
				},
			},
			'contextMenu': {
				'children': {
					'clickLayer': {
						'bottom': '0',
						'left': '0',
						'position': 'fixed',
						'right': '0',
						'top': '0',
						'zIndex': '999',
					},
				},
			},
			'heading': {
				'children': {
					'h3': {
						'color': '#001928',
						'font': {
							'family': '"Heebo Bold", sans-serif',
							'size': '16px !important',
							'weight': '700',
						},
						'lineHeight': '24px',
						'margin': {
							'bottom': '20px',
							'top': '30px',
						},
						'text': {
							'transform': 'uppercase',
						},
					},
				},
			},
			'image': {
				'width': '500px',
			},
			'list': {
				'children': {
					'listItemWrapper': {
						'listStyle': {
							'type': 'none',
						},
					},
				},
				'padding': {
					'_value': '0px 0px 0px 0px',
				},
			},
			'tooltip': {
				'children': {
					'arrowIcon': {
						'fill': 'white',
						'stroke': '#cccccc',
					},
					'clickLayer': {
						'background': {
							'color': 'transparent',
						},
						'bottom': '0',
						'left': '0',
						'position': 'fixed',
						'right': '0',
						'top': '0',
						'zIndex': '10',
					},
					'tooltipCharacter': {
						'background': {
							'color': '#1EA7FD',
						},
						'border': {
							'radius': '1.5em',
						},
						'color': 'white',
						'font': {
							'size': '9px',
						},
						'margin': {
							'_value': '0 0.5em',
						},
						'min': {
							'width': '1.5em',
						},
						'padding': {
							'bottom': '0.2em',
							'left': '0.5em',
							'right': '0.5em',
							'top': '0.2em',
						},
						'text': {
							'align': 'left',
						},
					},
					'tooltipContent': {
						'border': {
							'radius': '3px',
						},
						'color': 'rgb(0, 25, 40)',
						'font': {
							'family': '\'Heebo\', Arial',
							'size': '12px',
							'style': 'normal',
							'weight': '400',
						},
						'lineHeight': '18px',
						'overrides': [
							{
								'selector': '[data-selector="base-tooltip-arrowIconWrapper"]',
								'style': {
									'display': 'none',
									'left': '-11px',
									'position': 'absolute',
									'top': '-5px',
									'transform': 'rotate(90deg)',
								},
							},
						],
						'padding': {
							'_value': '10px',
						},
						'width': '100%',
					},
					'tooltipIcon': {
						'height': '13px',
						'width': '13px',
					},
					'tooltipIconButton': {
						'cursor': 'pointer',
						'margin': {
							'top': '25px',
						},
						'position': 'sticky',
					},
					'wrapper': {
						'display': 'inline-block',
						'lineHeight': 'normal',
						'margin': {
							'left': '2px',
							'top': '-4px',
						},
						'overrides': [
							{
								'selector': '[data-selector="base-tooltip-tooltipContentWrapper"]',
								'style': {
									'background': {
										'color': '#ffffff',
									},
									'border': {
										'radius': '3px',
									},
									'box': {
										'shadow': '0 4px 4px rgba(0,0,0,0.15)',
									},
									'breakpoints': [
										{
											'max': '767px',
											'style': {
												'left': '5px',
												'width': '265px',
											},
										},
									],
									'max': {
										'width': '380px',
									},
									'width': '380px',
									'zIndex': '9',
								},
							},
							{
								'selector': '[data-selector="base-tooltip-tooltipIconButton"]',
								'style': {
									'selectors': [
										{
											':hover': {
												'cursor': 'pointer',
											},
										},
									],
								},
							},
						],
						'verticalAlign': 'middle',
					},
				},
			},
		},
		'fact': {
			'fact': {
				'children': {
					'value': {
						'text': {
							'align': 'left',
						},
					},
				},
			},
		},
	},
};